<template>
  <div class="main-height bg-white layout dashboard__layout gf_survey">
    <div class="p-2">
      <div class="gf_survey-image"></div>
      <h4 class="gf_survey-title heading-h5-16-medium text-light-high mt-2 ">{{ $t("newonboarding.widget.firstStep.title") }}</h4>
      <p class="recent-pages__type body-14-regular text-dark6 mt-1 line-height-18">
        {{ $t("newonboarding.widget.firstStep.description") }}
      </p>
    </div>
    <button class="btn btn-light2 btn-sm btn-block btn-new-onboard-survey" @click="gotoStep">
      {{ $t("newonboarding.widget.firstStep.button") }}
    </button>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {actions as obActions} from "@/store/newonboarding/types";

export default {
  name: "Step1",
  methods: {
    ...mapActions("newonboarding", {
      onGotoStep: obActions.GO_TO_STEP
    }),
    gotoStep() {
      this.onGotoStep({step: 2});
    }
  }
}
</script>
<style lang="scss" scoped>
.gf_survey {
  &-image {
    background-image: url(~@/core/assets/new-dashboard/onboard/conversion-onboard.svg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    @media only screen and (min-width: 1024px) {
      height: 127px;
    }
    @media only screen and (min-width: 1120px) {
      height: 200px;
    }
  }

  &-title {

  }
}
</style>
